// VFX: Subscribe End Card
// Category: intros-outros · Tags: outro, subscribe, endcard, cta, youtube
// Full end card: subscribe CTA + recommended video placeholders.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, spring, interpolate } from "remotion";
import React from "react";

const clamp = { extrapolateLeft: "clamp", extrapolateRight: "clamp" } as const;

export interface SubscribeEndCardProps {
  channelName?: string;
  subText?: string;
  accentColor?: string;
}

export default function SubscribeEndCard({
  channelName = "@DimusChannel",
  subText = "Inscreva-se para mais",
  accentColor = "#ef4444",
}: SubscribeEndCardProps) {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const ctaP = spring({ frame, fps, config: { damping: 18, stiffness: 180 } });
  const card1 = spring({ frame: frame - 8, fps, config: { damping: 16, stiffness: 160 } });
  const card2 = spring({ frame: frame - 16, fps, config: { damping: 16, stiffness: 160 } });
  const pulse = 1 + Math.sin(frame * 0.12) * 0.03;
  return (
    <AbsoluteFill style={{ background: "linear-gradient(180deg, #0a0e1a 0%, #0f172a 100%)", padding: "120px 60px", display: "flex", flexDirection: "column", gap: 50 }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 24, opacity: ctaP, transform: `translateY(${interpolate(ctaP, [0, 1], [30, 0], clamp)}px)` }}>
        <div style={{ width: 160, height: 160, borderRadius: "50%", background: "linear-gradient(135deg, #a855f7, #06b6d4)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 72, fontWeight: 900, color: "#fff", fontFamily: "system-ui", boxShadow: "0 12px 40px rgba(168,85,247,0.4)" }}>
          D
        </div>
        <div style={{ fontSize: 48, fontWeight: 900, color: "#f8fafc", fontFamily: "system-ui" }}>{channelName}</div>
        <button style={{
          background: accentColor, color: "#fff",
          border: "none", borderRadius: 100,
          padding: "20px 56px", fontSize: 28, fontWeight: 800,
          fontFamily: "system-ui",
          transform: `scale(${pulse})`,
          boxShadow: `0 8px 32px ${accentColor}66`,
          cursor: "pointer", letterSpacing: 1,
        }}>
          ▶ {subText.toUpperCase()}
        </button>
      </div>
      <div style={{ display: "flex", gap: 24, justifyContent: "center", marginTop: "auto" }}>
        {[card1, card2].map((p, i) => (
          <div key={i} style={{
            width: 420, height: 240, borderRadius: 16,
            background: `linear-gradient(135deg, ${i === 0 ? "#1e293b" : "#334155"}, #0f172a)`,
            border: "1px solid rgba(255,255,255,0.08)",
            opacity: p, transform: `translateY(${interpolate(p, [0, 1], [40, 0], clamp)}px)`,
            display: "flex", alignItems: "flex-end", padding: 20,
            color: "#f8fafc", fontWeight: 700, fontFamily: "system-ui", fontSize: 18,
          }}>
            ▶ Vídeo recomendado {i + 1}
          </div>
        ))}
      </div>
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
